import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "govuk-cookie-banner",
  "data-nosnippet": "",
  role: "region",
  "aria-label": "Cookies on [name of service]"
}
const _hoisted_2 = { class: "govuk-cookie-banner__message govuk-width-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-grid-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "govuk-grid-column-two-thirds" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "govuk-cookie-banner__heading govuk-heading-m" }, "Cookies on Find a will"),
    /*#__PURE__*/_createElementVNode("div", { class: "govuk-cookie-banner__content" }, [
      /*#__PURE__*/_createElementVNode("p", null, "We use some essential cookies to make this service work."),
      /*#__PURE__*/_createElementVNode("p", null, "We'd also like to use analytics cookies so we can understand how you use the service and make improvements.")
    ])
  ])
], -1)
const _hoisted_4 = { class: "govuk-button-group" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("View cookies")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptCookies && _ctx.acceptCookies(...args))),
          value: "accept",
          type: "button",
          name: "cookies",
          class: "govuk-button",
          "data-module": "govuk-button"
        }, " Accept analytics cookies "),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejectCookies && _ctx.rejectCookies(...args))),
          value: "reject",
          type: "button",
          name: "cookies",
          class: "govuk-button",
          "data-module": "govuk-button"
        }, " Reject analytics cookies "),
        _createVNode(_component_router_link, {
          class: "govuk-link",
          to: {name: 'Cookies'}
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.showCookieBanner]
  ])
}